import React, { useEffect, useState } from 'react';
import { Col, Row, Card , Button, Space, Modal} from 'antd';
import griddedHistorical from '@/resource/icon-png/griddedNew.png';
import hyperLocal from '@/resource/icon-png/hyperNew.png';
import soilProfile from '@/resource/icon-png/soilProfileNew.png';
import agriAlert from '@/resource/icon-png/agriAlert.jpg';
import weatherHistorical from '@/resource/icon-png/weatherHistoricalNew.png';
import weatherForecast from '@/resource/icon-png/weatherForecastNew.png';
import { portalProceedModuleSelect, soilGetAuthenticate, soilSelfGetService ,agriAlertGetAuthenticate} from '@/util/Request';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentSys } from '@/redux/reducer/common';
import { Link, useNavigate } from 'react-router-dom';
import '/node_modules/video-react/dist/video-react.css';
import './index.less';
import { SoilCloseIcon, SoilProfileWarningAlertIcon } from '@/resource/IconComponentSets';
import { RootState } from '@reduxjs/toolkit';
import { updateCurrentRoleId, updateCurrentUserId, updateTab } from '@/redux/reducer/agrialertTemplate';
const { Meta } = Card;
const { confirm } = Modal;

export default function Home() {
    const [url, setUrl] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const refreshModalShow = useSelector((state: RootState) => state.commonData.refreshModalShow);
    useEffect(() => {
        // const token = localStorage.getItem('accessToken');
        if (url.length === 0) {
            getAllService();
        }
    }, []);

    useEffect(() => {
        console.log('just invoke once');
        const head = document.getElementsByTagName('head')[0];
        const googleAnalyticsCode = 'G-82SB362F9Z';
        const googleAnalyticsFirstScript = document.createElement('script');
        googleAnalyticsFirstScript.async = true;
        googleAnalyticsFirstScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsCode;

        const googleAnalyticsSecondScript = document.createElement('script');
        googleAnalyticsSecondScript.innerHTML =
          '    window.dataLayer = window.dataLayer || [];\n' +
          '    function gtag(){dataLayer.push(arguments);}\n' +
          '    gtag(\'js\', new Date());\n' +
          '\n' +
          '    gtag(\'config\', \'' +
          googleAnalyticsCode +
          '\',{\n' +
          'cookie_flags:\'max-age=7200;secure;samesite-none\'' +
          '});';

        head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
        head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
    }, []);

    const getAllService = async () => {
        try {
            const res = await soilSelfGetService();
            setUrl(res);
        } catch (err) {
            console.log('home err', err);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [secondModalOpen, setSecondModalOpen] = useState(false);
    const [thirdModalOpen, setThirdModalOpen] = useState(false);
    const [fourthModalOpen, setFourthModalOpen] = useState(false);
    const [fifthModalOpen, setFifthModalOpen] = useState(false);
    const [sixthModalOpen, setSixthModalOpen] = useState(false);


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleRefresh = () => {
        console.log('handleRefresh');
        window.location.reload();
    };

    const showWarningMessage = (newContent) => {
        confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: newContent,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('ok');
            }
        });
    };

    return (
        <div className="home">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <iframe
                    id="kmsembed-1_13ln7vix"
                    width="0"
                    height="0"
                    src={url}
                />
                <Col xxl={24} xl={24} lg={24} md={24} xs={24} sm={24}
                    className='titlePartStyle'>
                    <p className="welcomeFont">Welcome to CE Hub </p>
                    <p className="cropFont">Crop Environmental data hub</p>
                </Col>
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={griddedHistorical} />}>
                        <Meta
                            className='title-text'
                            title="Gridded Historical Weather Data" description="
                            The global Crop Environmental data is provided through a
                            powerful self-service portal and APIs, both supporting queries
                            over large spatial and temporal extend including powerful
                            filters, aggregations and transformations."
                        />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={showModal}>Know More</Button>
                                <Modal title="Gridded Historical Weather Data"
                                    open={isModalOpen}
                                    width={690}
                                    onOk={(handleOk)}
                                    onCancel={handleCancel}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    destroyOnClose={true}
                                    closeIcon={<SoilCloseIcon />}
                                >
                                    <div className='home-modal-body'>
                                        {/* <Player
                                            playsInline
                                            poster={viedo}
                                            //src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                                            src="https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0"
                                        /> */}
                                        {/* <div>
                                            <iframe style={{width:'660px',height:'255px'}}>
                                                <a href='https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0'>
                                                    <image
                                                        width={660}
                                                        height={255}
                                                        src={viedo}
                                                    />
                                                </a>
                                            </iframe>
                                        </div> */}
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src="https://videos.syngenta.com/media/CE+Hub+-+Gridded+Historical+Weather+Data+Quick+Demo/1_mwi4af32"
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                                    allow-top-navigation allow-pointer-lock allow-popups
                                                    allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                                    allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">

                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>
                                                    The global Crop Environmental data is
                                                    provided through a powerful self-service
                                                    portal and APIs, both supporting queries
                                                    over large spatial and temporal extend
                                                    including powerful filters, aggregations
                                                    and transfor-mations. The Syngenta soil
                                                    analysis tool is a repository for the
                                                    storage of soil sample analysis generated
                                                    internally. Soil profiles can be established
                                                    for open field or greenhouse.</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                <a href={url} onClick={() => {
                                                    portalProceedModuleSelect('self-service portal');
                                                }}>
                                                    <Button className='start'>Start</Button>
                                                </a>
                                            </Col>
                                        </Row>

                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a href='https://docs.meteoblue.com/en/meteo/data-sources/datasets'><button className='spanContent'>View Documentation</button><br/></a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                                <a href={url} onClick={() => {
                                    portalProceedModuleSelect('self-service portal');
                                }}>
                                    <Button className='start'>Start</Button>
                                </a>
                            </Space>
                        </div>
                    </Card>
                </Col>
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={hyperLocal} />}
                    >
                        <Meta
                            className='title-text'
                            title="Hyper-Local Historical Weather Data"
                            description="The hyper-local weather data can be
                                accessible using self-service portal and APIs
                                for system-to-system integration."
                        />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={() => setSecondModalOpen(true)}>Know More</Button>
                                <Link to="/weatherQuery" onClick={() => {
                                    dispatch(updateCurrentSys('weather'));
                                    portalProceedModuleSelect('weather station query');
                                }}>
                                    <Button className='start'>Start</Button>
                                </Link>
                                <Modal title="Hyper-Local Historical Weather Data"
                                    open={secondModalOpen}
                                    width={690}
                                    onOk={() => setSecondModalOpen(false)}
                                    onCancel={() => setSecondModalOpen(false)}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    closeIcon={<SoilCloseIcon />}
                                    destroyOnClose={true}
                                >
                                    <div className='home-modal-body'>
                                        {/* <Player
                                            playsInline
                                            poster={viedo}
                                            //src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                                            src="https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0"
                                        /> */}
                                        {/* <div>
                                            <iframe style={{width:'660px',height:'255px'}}>
                                                <a href='https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0'>
                                                    <image
                                                        width={660}
                                                        height={255}
                                                        src={viedo}
                                                    />
                                                </a>
                                            </iframe>
                                        </div> */}
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src="https://videos.syngenta.com/media/CE+Hub+-+Hyper-Local+Historical+Weather+Data+Quick+Demo/1_j0ajhmku"
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                        allow-top-navigation allow-pointer-lock allow-popups
                                        allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                        allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">

                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>
                                                The hyper-local weather data can be
                                                accessible using self-service portal and APIs
                                                for system-to-system integration.</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                <Link to="/weatherQuery" onClick={() => {
                                                    dispatch(updateCurrentSys('weather'));
                                                    portalProceedModuleSelect('weather station query');
                                                }}>
                                                    <Button className='start'>Start</Button>
                                                </Link>
                                            </Col>
                                        </Row>

                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a
                                                        href='https://syngenta.sharepoint.com/:b:/s/DigitalInnovationLabs/Eals8clEontMm0GIG4BlWIcBHn0hri-y1zQQtf9O6KXkOw?e=DLh2gN'
                                                    >
                                                        <button className='spanContent'>
                                                            View Documentation
                                                        </button><br/>
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                            </Space>
                        </div>
                    </Card>
                </Col>
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={soilProfile} />}
                    >
                        <Meta
                            className='title-text'
                            title="Soil Profile Analysis" description="The Syngenta soil analysis
                             tool is a repository for the storage of soil sample
                             analysis generated internally. Soil profiles can be
                             established for open field or greenhouse and shared
                             internally for potential reuse." />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={() => setThirdModalOpen(true)}>Know More</Button>
                                <Button
                                    className='start'
                                    onClick={async () => {
                                        portalProceedModuleSelect('soil analysis');
                                        const authenticate = await soilGetAuthenticate();
                                        const authenticateData = authenticate.data;
                                        if (authenticateData.userIsActive) {
                                            navigate('/soilhub');
                                            dispatch(updateCurrentSys('soil'));
                                        } else {
                                            showWarningMessage('You do not have access to the soil analysis system, please contact the support team.');
                                        }
                                    }}
                                >
                                    Start
                                </Button>
                                <Modal title="Soil Profile Analysis"
                                    open={thirdModalOpen}
                                    width={690}
                                    onOk={() => setThirdModalOpen(false)}
                                    onCancel={() => setThirdModalOpen(false)}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    destroyOnClose={true}
                                    closeIcon={<SoilCloseIcon />}
                                >
                                    <div className='home-modal-body'>
                                        {/* <Player
                                            playsInline
                                            poster={viedo}
                                            //src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                                            src="https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0"
                                        /> */}
                                        {/* <div>
                                            <iframe style={{width:'660px',height:'255px'}}>
                                                <a href='https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0'>
                                                    <image
                                                        width={660}
                                                        height={255}
                                                        src={viedo}
                                                    />
                                                </a>
                                            </iframe>
                                        </div> */}
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src="https://videos.syngenta.com/media/CE+Hub+-+Soil+Profile+Analysis+Quick+Demo/1_ujw0ompf"
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                        allow-top-navigation allow-pointer-lock allow-popups
                                        allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                        allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">

                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>
                                                The Syngenta soil analysis
                                                tool is a repository for the storage of soil sample
                                                analysis generated internally. Soil profiles can be
                                                established for open field or greenhouse and shared
                                                internally for potential reuse.</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                {/* <Link to="/search" onClick={() => {
                                                    dispatch(updateCurrentSys('soil'));
                                                    portalProceedModuleSelect('soil analysis');
                                                }}> */}
                                                <Button
                                                    className='start'
                                                    onClick={async () => {
                                                        const authenticate = await soilGetAuthenticate();
                                                        const authenticateData = authenticate.data;
                                                        if (authenticateData.userIsActive) {
                                                            navigate('/soilhub');
                                                            dispatch(updateCurrentSys('soil'));
                                                            portalProceedModuleSelect('soil analysis');
                                                        } else {
                                                            showWarningMessage('You do not have access to the soil analysis system, please contact the support team.');
                                                        }
                                                    }}
                                                >
                                                        Start
                                                </Button>
                                                {/* </Link> */}
                                            </Col>
                                        </Row>

                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a
                                                        href='https://syngenta.sharepoint.com/sites/ce-hub/SitePages/Syngenta-Soil-Analysis.aspx'
                                                    >
                                                        <button className='spanContent'>
                                                            View Documentation
                                                        </button><br/>
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                            </Space>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{marginTop:'20px'}} >
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={weatherHistorical} />}>
                        <Meta
                            className='title-text'
                            title="Weather Historical Map" description="Map visualization of historical weather data for different weather variables"
                        />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={() => setFourthModalOpen(true)}>Know More</Button>
                                <a onClick={() => {
                                    portalProceedModuleSelect('weather historictal map');
                                }}
                                href={url}>
                                    <Button className='start'>Start</Button>
                                </a>
                                <Modal title="Weather Historical Map"
                                    open={fourthModalOpen}
                                    width={690}
                                    onOk={() => setFourthModalOpen(false)}
                                    onCancel={() => setFourthModalOpen(false)}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    destroyOnClose={true}
                                    closeIcon={<SoilCloseIcon />}
                                >
                                    <div className='home-modal-body'>
                                        {/* <Player
                                            playsInline
                                            poster={viedo}
                                            //src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                                            src="https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0"
                                        /> */}
                                        {/* <div>
                                            <iframe style={{width:'660px',height:'255px'}}>
                                                <a href='https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0'>
                                                    <image
                                                        width={660}
                                                        height={255}
                                                        src={viedo}
                                                    />
                                                </a>
                                            </iframe>
                                        </div> */}
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src="https://videos.syngenta.com/media/CE+Hub+-+Weather+Historical+Map+Quick+Demo/1_yv72yijz"
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                        allow-top-navigation allow-pointer-lock allow-popups
                                        allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                        allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">
                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>Map visualization of historical weather data for different weather variables</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                <a href={url}>
                                                    <Button onClick={() => {
                                                        portalProceedModuleSelect('weather historictal map');
                                                    }} className='start'>Start</Button>
                                                </a>
                                            </Col>
                                        </Row>

                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a
                                                        href='https://content.meteoblue.com/en/private-customers/website-help/weather-maps'
                                                    >
                                                        <button className='spanContent'>
                                                            View Documentation
                                                        </button><br/>
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                            </Space>
                        </div>
                    </Card>
                </Col>
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={weatherForecast} />}
                    >
                        <Meta
                            className='title-text'
                            title="Weather Forecast Map" description="Map visualization of forecast weather data for different weather variables" />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={() => setFifthModalOpen(true)}>Know More</Button>
                                <a onClick={() => {
                                    portalProceedModuleSelect('weather forecast map');
                                }} href={url} >
                                    <Button className='start'>Start</Button>
                                </a>
                                <Modal title="Weather Forecast Map"
                                    open={fifthModalOpen}
                                    width={690}
                                    onOk={() => setFifthModalOpen(false)}
                                    onCancel={() => setFifthModalOpen(false)}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    closeIcon={<SoilCloseIcon />}
                                    destroyOnClose={true}
                                >
                                    <div className='home-modal-body'>
                                        {/* <Player
                                            playsInline
                                            poster={viedo}
                                            //src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                                            src="https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0"
                                        /> */}
                                        {/* <div>
                                            <iframe style={{width:'660px',height:'255px'}}>
                                                <a href='https://videos.syngenta.com/embed/secure/iframe/entryId/1_qmjmrvg3/uiConfId/44228611/st/0'>
                                                    <image
                                                        width={660}
                                                        height={255}
                                                        src={viedo}
                                                    />
                                                </a>
                                            </iframe>
                                        </div> */}
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src="https://videos.syngenta.com/media/CE+Hub+-+Weather+Forecast+Map+Quick+Demo/1_u12j1bge"
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                        allow-top-navigation allow-pointer-lock allow-popups
                                        allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                        allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">

                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>
                                                Map visualization of forecast weather data for different weather variables</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                <a href={url} >
                                                    <Button onClick={() => {
                                                        portalProceedModuleSelect('weather forecast map');
                                                    }} className='start'>Start</Button>
                                                </a>
                                            </Col>
                                        </Row>

                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a
                                                        href='https://content.meteoblue.com/en/private-customers/website-help/weather-maps'
                                                    >
                                                        <button className='spanContent'>
                                                            View Documentation
                                                        </button><br/>
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                            </Space>
                        </div>
                    </Card>
                </Col>
                {/* new added */}
                <Col className="gutter-row" lg={8} md={12} sm={24} xs={24}>
                    <Card
                        hoverable
                        className='item'
                        cover={<img alt="example" src={agriAlert} />}
                    >
                        <Meta
                            className='title-text'
                            title="AgriAlert Portal"
                            description="The Agrialert Portal is designed to create recurring emails containing customized weather insights and agronomic decision recommendations." />
                        <div className='right'>
                            <Space>
                                <Button className='knowMore' onClick={() => setSixthModalOpen(true)}>Know More</Button>
                                <Button
                                    className='start'
                                    onClick={async () => {
                                        const result=await portalProceedModuleSelect('agri alert');
                                        if(result==='Success'){
                                            console.log('6666:',result);
                                            const authenticate = await agriAlertGetAuthenticate('agri alert');
                                            console.log('6666:',typeof(authenticate.roleId));
                                            if (authenticate.userIsActive) {
                                                navigate('/agrialert/template');
                                                dispatch(updateCurrentSys('agrialert'));
                                                dispatch(updateCurrentUserId(authenticate.userId));
                                                dispatch(updateCurrentRoleId(authenticate.roleId));
                                                if((authenticate.roleId===1)||(authenticate.roleId===4))
                                                    dispatch(updateTab(Number(1)));
                                                if(authenticate.roleId===3)
                                                    dispatch(updateTab(Number(3)));
                                            } else {
                                                showWarningMessage('You do not have access to the AgriAlert system, please contact the support team.');
                                            }
                                        }
                                    }}
                                >
                                    Start
                                </Button>
                                <Modal title="AgriAlert Portal"
                                    open={sixthModalOpen}
                                    width={690}
                                    onOk={() => setSixthModalOpen(false)}
                                    onCancel={() => setSixthModalOpen(false)}
                                    footer={null}
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}
                                    destroyOnClose={true}
                                    closeIcon={<SoilCloseIcon />}
                                >
                                    <div className='home-modal-body'>
                                        <iframe id="kmsembed-1_13ln7vix"
                                            width="645" height="255"
                                            src=""
                                            className="kmsembed"
                                            allow="fullscreen *; encrypted-media *"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts
                                        allow-top-navigation allow-pointer-lock allow-popups
                                        allow-modals allow-orientation-lock allow-popups-to-escape-sandbox
                                        allow-presentation allow-top-navigation-by-user-activation"
                                            frameBorder="0" title="CE Hub webinar on weather station self service portal">

                                        </iframe>
                                        <Row className='rowMt16'>
                                            <Col span={20}>
                                                <p className='pModalStyle'>
                                                The Agrialert Portal is designed to create recurring emails containing customized weather insights and agronomic decision recommendations.</p>
                                            </Col>
                                            <Col span={4} style={{textAlign:'right'}}>
                                                <Button
                                                    className='start'
                                                    onClick={async () => {
                                                        const result=await portalProceedModuleSelect('agri alert');
                                                        if(result==='Success'){
                                                            const authenticate = await agriAlertGetAuthenticate('agri alert');
                                                            if (authenticate.userIsActive) {
                                                                navigate('/agrialert/template');
                                                                dispatch(updateCurrentSys('agrialert'));
                                                                dispatch(updateCurrentUserId(authenticate.userId));
                                                                dispatch(updateCurrentRoleId(authenticate.roleId));
                                                                if((authenticate.roleId===1)||(authenticate.roleId===4))
                                                                    dispatch(updateTab(Number(1)));
                                                                if(authenticate.roleId===3)
                                                                    dispatch(updateTab(Number(3)));
                                                                // portalProceedModuleSelect('agri alert');
                                                            } else {
                                                                showWarningMessage('You do not have access to the AgriAlert system, please contact the support team.');
                                                            }
                                                        }
                                                    }}
                                                >
                                                        Start
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className='rowMt25' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Get to know more about the services of our application</span><br/>
                                                    <a
                                                        href=''
                                                    >
                                                        <button className='spanContent'>
                                                            View Documentation
                                                        </button><br/>
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <div className='divStyle'>
                                                    <span className='spanTitle'>Your thoughts are valuable in helping us to improve our application.</span><br/>
                                                    <a href='/feedback'><button className='spanContent'>Send Feedback</button><br/></a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal>
                            </Space>
                        </div>
                    </Card>
                </Col>
            </Row>
            <div className="footStyle">
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} >
                    <Col span={24}>
                        <span className='titleStyle'>Contact information</span>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{marginTop:'25px'}}>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <span className='nameStyle'>Kethireddy Pradeep CHBS</span><br/>
                        <span className='roleStyle'>Platform Manager</span><br/>
                        <a href='mailto:pradeep.kethireddy@syngenta.com?subject=My feedback'><p className="mailFont">pradeep.kethireddy@syngenta.com</p></a>
                    </Col>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <span className='nameStyle'>Irene Caramatti CHBS</span><br/>
                        <span className='roleStyle'>Environmental Data analyst</span><br/>
                        <a href='mailto:irene.caramatti@syngenta.com?subject=My feedback'><p className="mailFont">irene.caramatti@syngenta.com</p></a>
                    </Col>
                </Row>
            </div>
            <div style={{height:'38px'}}></div>
            <Modal
                open={refreshModalShow}
                width={400}
                footer={null}
                style={{
                    borderRadius: '10px',
                    overflow: 'hidden'
                }}
                destroyOnClose={true}
                closeIcon={<div/>}
            >
                <div className='refresh-modal'>
                    <label className='warning-label'>Warning</label>
                    <div className='notice-label'>
                        <label>Please confirm your network is reachable and refresh!</label>
                    </div>
                    <button className='confirm-button' onClick={handleRefresh}>Confirm</button>
                </div>
            </Modal>
        </div>
    );
}
